import { Icon } from '@legacy/components/ui-components/Icon';

export const IconRight = () => <Icon iconName="arrowRight" size="small" />;
